import { Component } from '@angular/core';
import { Icon } from "../../../shared/components/icon";
import { MenuMobile } from "../menu-mobile";
import { itemLink, MenuItem } from '../../../shared/models/menu-item';
import { Divider } from '../../../shared/components/divider';
@Component({
  selector: 'app-footer-mobile',
  templateUrl: './footer-mobile.html',
  styleUrls: ['./footer-mobile.scss'],
  imports: [Icon, MenuMobile, Divider],
})
export class FooterMobile {
  munuLinks: MenuItem[] = [
    {
      id: "contatti",
      title: "contatti",
      items: [
        {
          title: "Dove Siamo",
          href: "https://questure.poliziadistato.it/it/servizio/dovesiamo",
        },
        {
          title: "Scrivici",
          href: "https://www.poliziadistato.it/scrivici/message",
        },
      ]
    },
    {
      id: "socialNetwork",
      title: "social network",
      items: [
        {
          title: "Facebook",
          href: "https://www.facebook.com/poliziadistato.it?fref=ts",
        },
        {
          title: "Instagram",
          href: "https://www.instagram.com/poliziadistato/",
        },
        {
          title: "X",
          href: "https://x.com/poliziadistato",
        },
        {
          title: "YouTube",
          href: "https://www.youtube.com/user/poliziadistato",
        },
        {
          title: "Telegram",
          href: "https://t.me/poliziadistato",
        },
      ]
    },
    {
      id: "linkUtili",
      title: "link utili",
      items: [
        {
          title: "Polizia Moderna",
          href: "https://poliziamoderna.poliziadistato.it/",
        },
/*         {
          title: "Doppiavela",
          href: "https://dv.poliziadistato.it/login?redirect_url=/",
        }, */
        {
          title: "Commissariato di PS Online",
          href: "https://www.commissariatodips.it/",
        },
/*         {
          title: "Rassegna Stampa",
          href: "https://www.poliziadistato.it/pds/ps/ufficiostampa/rassegna_stampa/pw_rassegna_stampa.htm",
        }, */
      ]
    },
    {
      id: "assistenza",
      title: "assistenza al cittadino",
      items: [
        {
          title: "1-1-2 Numero Unico Europeo",
          href: "https://112.gov.it/",
        }
      ]
    },
  ];

  utilsLinks: itemLink[] = [
/*     {
      label: "Dichiarazione di Accessibilità",
      href: "#"
    },
    {
      label: "Note Legali",
      href: "#"
    },
    {
      label: "Privacy e Cookie Policy",
      href: "#"
    } */
  ];

}
